import { z } from "zod/v4";
import { durationSchema, timeDashboardSchema } from "./time.js";
const RESOLUTION_LEVELS = [
    'Low',
    'Medium',
    'High'
];
const resolutionLevelsSchema = z["enum"](RESOLUTION_LEVELS);
const DEFAULT_QUERY_RESOLUTION = 'Medium';
const INTERVAL_SIZE_LEVELS = [
    'Small',
    'Medium',
    'Large'
];
const intervalSizeLevelsSchema = z["enum"](INTERVAL_SIZE_LEVELS);
const DEFAULT_INTERVAL_VARIABLE_SIZE = 'Medium';
const intervalSizeToResolution = {
    Small: 'High',
    Medium: 'Medium',
    Large: 'Low'
};
function isValidIntervalSizeLevel(value) {
    return 'string' == typeof value && INTERVAL_SIZE_LEVELS.includes(value);
}
const QUERY_OPTIONS_URL_PARAM = 'query_options';
const resolutionSchema = z.union([
    resolutionLevelsSchema,
    durationSchema
]);
const queryOptionsSchema = z.object({
    resolution: resolutionSchema.optional(),
    time: timeDashboardSchema.optional()
});
export { DEFAULT_INTERVAL_VARIABLE_SIZE, DEFAULT_QUERY_RESOLUTION, INTERVAL_SIZE_LEVELS, QUERY_OPTIONS_URL_PARAM, RESOLUTION_LEVELS, intervalSizeLevelsSchema, intervalSizeToResolution, isValidIntervalSizeLevel, queryOptionsSchema, resolutionLevelsSchema, resolutionSchema };

//# sourceMappingURL=query-options.js.map